// Copyright (c) 2017 Peter Graham, contributors. Released under the Apache-2.0 license.

var words = ['aga', 'ei', 'et', 'ja', 'jah', 'kas', 'kui', 'kõik', 'ma', 'me', 'mida', 'midagi', 'mind', 'minu', 'mis', 'mu', 'mul', 'mulle', 'nad', 'nii', 'oled', 'olen', 'oli', 'oma', 'on', 'pole', 'sa', 'seda', 'see', 'selle', 'siin', 'siis', 'ta', 'te', 'ära'];
exports.words = words;